document.addEventListener("DOMContentLoaded", () => {
  const machineModal = document.getElementById("machineFormModal");
  const form = document.getElementById("machineForm");
  const saveBtn = document.getElementById("saveMachineBtn");

  // Listen for dropdown edit clicks
  document.querySelectorAll("[data-action='edit'][href='#machineFormModal']").forEach(link => {
    link.addEventListener("click", () => {
      form.dataset.machineId = link.dataset.machineId;
      document.getElementById("machine_name").value = link.dataset.machineName;
      document.getElementById("machine_description").value = link.dataset.machineDescription;
    });
  });

  // Save handler
  if (saveBtn) {
    saveBtn.onclick = function () {
      const machineId = form.dataset.machineId;
      const url = machineId ? `/machines/${machineId}` : "/machines";
      const method = machineId ? "PATCH" : "POST";

      const payload = {
        name: document.getElementById("machine_name").value,
        description: document.getElementById("machine_description").value
      };

      fetch(url, {
        method: method,
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
        },
        body: JSON.stringify({ machine: payload })
      })
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            window.location.reload();
          } else {
            alert(data.errors ? data.errors.join(", ") : data.error || "Error saving machine");
          }
        })
        .catch(error => {
          console.error("Error:", error);
          alert("Network error saving machine");
        });
    };
  }
});
